import { cssVar } from '@chakra-ui/styled-system';
import { StyleFunctionProps } from '@chakra-ui/theme-tools';
import Input from './input';

const $bg = cssVar('select-bg');

const { sizes, defaultProps, variants } = Input;

function baseStyleField(_: StyleFunctionProps) {
  return {
    ...Input.baseStyle.field,
    appearance: 'none',
    paddingBottom: '1px',
    lineHeight: 'normal',
    bg: $bg.reference,
    [$bg.variable]: 'colors.white',
    _dark: {
      '> option': {
        bg: 'gray.1000',
        color: 'white',
      },
    },
    '> option': {
      bg: 'white',
      color: 'gray.800',
    },
    '> option, > optgroup': {
      bg: $bg.reference,
    },
  };
}

const baseStyle = (props: StyleFunctionProps) => ({
  field: baseStyleField(props),
});

export default {
  baseStyle,
  sizes,
  variants,
  defaultProps,
};
